export default function authHeader() {
  const token = localStorage.getItem("userToken");

  if (token) {
    return { "x-access-token": token }; // for Node.js Express back-end
  } else {
    return {};
  }
}
